import Phaser from 'phaser';
import Cloud from './Cloud';
import Tree from './Tree';
import Sparkle from './Sparkle';
import PoolParticle from './PoolParticle';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import Pipe from './Pipe';

export default class BackgroundLayers extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {Phaser.GameObjects.Container} frontLayer
   */
  constructor(scene, frontLayer) {
    super(scene);
    this.frontLayer = frontLayer;

    this.cloudWaitMin = 18;
    this.cloudWaitMax = 40;

    this.treeWaitMin = 13;
    this.treeWaitMax = 30;

    this.baseTreeSpeed = 200;
    this.baseCloudSpeed = 72;

    this.treeSpeed = 200;
    this.cloudSpeed = 72;

    this.isMoving = true;

    /** @type {Cloud[]} */
    this.clouds = [];
    this.cloudPool = [
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
      new Cloud(this.scene),
    ];
    this.cloudWaitTime = 2;
    this.cloudWaiter = 2;

    /** @type {Tree[]} */
    this.trees = [];
    this.treePool = [
      new Tree(this.scene),
      new Tree(this.scene),
      new Tree(this.scene),
      new Tree(this.scene),
      new Tree(this.scene),
      new Tree(this.scene),
    ];
    this.treeWaitTime = 1.5;
    this.treeWaiter = 1.5;

    /** @type {Sparkle[]} */
    this.sparks = [];
    this.sparkPool = [];
    for (let i = 0; i < 120; i++) {
      this.sparkPool.push(new Sparkle(this.scene));
    }

    /** @type {PoolParticle[]} */
    this.caneChunks = [];
    this.caneChunksPool = [];
    for (let i = 0; i < 80; i++) {
      this.caneChunksPool.push(new PoolParticle(this.scene));
    }

    this.pipeCrashSprites = [];
  }

  spawnCloud () {
    const c = this.cloudPool.pop();
    if (c) {
      c.reset(this.scene.scale.width + 200, Phaser.Math.Between(0,160) - 10, -200, this.cloudSpeed);
      this.clouds.push(c);
      this.add(c.setVisible(true)).bringToTop(c);
    }
    else {
      console.log('too many clouds');
    }
  }

  returnCloud (i) {
    const c = this.clouds[i];
    c.setVisible(false);
    this.cloudPool.push(c);
    this.clouds.splice(i,1);
  }

  spawnTree () {
    const t = this.treePool.pop();
    if (t !== undefined) {
      t.reset(this.scene.scale.width + 200, this.scene.scale.height - 62, -200, this.treeSpeed);
      this.trees.push(t);
      this.frontLayer.add(t.setVisible(true)).bringToTop(t);
    }
    else {
      console.log('too many trees');
    }
  }

  returnTree (i) {
    const t = this.trees[i];
    t.setVisible(false);
    this.treePool.push(t);
    this.trees.splice(i,1);
  }

  makeSparkles (x,y,count = 12, movefast = false) {
    let s = null;
    const vx = 300;
    const vy = -300;
    let tx; let ty;
    for (let i = 0; i < count; i++) {
      tx = (Math.random() - 0.5) * vx;
      ty = (Math.random() - 0.5) * vy;
      s = this.sparkPool.pop();
      if (s === undefined) return;
      let lt = 1.4;
      if (movefast === true) {
        tx = -Phaser.Math.Between(200,420);
        lt *= 0.75;
      }
      s.reset(x,y,tx,ty,lt, movefast);
      this.sparks.push(s);
      this.add(s.setVisible(true)).bringToTop(s);
    }
  }

  returnSparkle (i) {
    const s = this.sparks[i];
    s.setVisible(false);
    this.sparkPool.push(s);
    this.sparks.splice(i,1);
  }

  makeCaneChunks (x, y, count = 12) {
    let s = null;
    const vx = -300;
    const vy = -300;
    let tx; let ty;
    for (let i = 0; i < count; i++) {
      tx = Math.random() * vx;
      ty = (Math.random() - 0.5) * vy;
      s = this.caneChunksPool.pop();
      if (s === undefined) {
        console.log('too many chunks');
        return;
      }
      s.reset(x,y,tx,ty,2);
      this.caneChunks.push(s);
      this.add(s.setVisible(true)).bringToTop(s);
    }
  }

  returnCaneChunk (i) {
    const c = this.caneChunks[i];
    c.setVisible(false);
    this.caneChunksPool.push(c);
    this.caneChunks.splice(i,1);
  }

  /**
 * 
 * @param {Pipe} pipe 
 */
  makeFallingCane (pipe) {
    const sprite = ABCyaPhaser.Images.addImage(pipe.x,pipe.y, pipe.frame.name, this).setOrigin(0);
    ABCyaPhaser.Tweens.addTween(sprite, 1400, { y: this.scene.scale.height }, Phaser.Math.Easing.Quadratic.In, () => this.removeCane(sprite));
    this.pipeCrashSprites.push(sprite);
  };

  removeCane (sprite) {
    const i = this.pipeCrashSprites.indexOf(sprite);
    sprite.destroy();
    this.pipeCrashSprites.splice(i,1);
  }

  changeSpeed (worldspeed) {
    this.treeSpeed = this.baseTreeSpeed * worldspeed;
    this.cloudSpeed = this.baseCloudSpeed * worldspeed;
    let len = 0;
    len = this.clouds.length;
    for (let i = 0; i < len; i++) {
      this.clouds[i].speed = -this.cloudSpeed;
    }
    len = this.trees.length;
    for (let i = 0; i < len; i++) {
      this.trees[i].speed = -this.treeSpeed;
    }

    // yucky but whatever
    this.cloudWaitMin = 18 * (1 / worldspeed);
    this.cloudWaitMax = 40 * (1 / worldspeed);
    this.treeWaitMin = 13 * (1 / worldspeed);
    this.treeWaitMax = 30 * (1 / worldspeed);
  }

  setGameOver (gameover) {
    if (gameover === true) {
      this.isMoving = false;
    }
    else {
      this.isMoving = true;

      // clean up any crash ones
      const len = this.pipeCrashSprites.length;
      for (let i = 0; i < len; i++) {
        this.pipeCrashSprites[i].destroy();
      }
      this.pipeCrashSprites = [];
    }
  }

  tick (dt) {
    let len = this.sparks.length - 1;
    let alive = false;
    for (let i = len; i >= 0; i--) {
      alive = this.sparks[i].tick(dt);
      if (alive === false) {
        this.returnSparkle(i);
      }
      else {
        this.sparks[i].updatePos();
      }
    }

    len = this.caneChunks.length - 1;
    alive = false;
    for (let i = len; i >= 0; i--) {
      alive = this.caneChunks[i].tick(dt);
      if (alive === false) {
        this.returnCaneChunk(i);
      }
      else {
        this.caneChunks[i].updatePos();
      }
    }

    if (this.isMoving) {
      this.doLayerMove(dt);
    }
  }

  doLayerMove (dt) {
    let len = this.clouds.length - 1;
    for (let i = len; i >= 0; i--) {
      this.clouds[i].tick(dt);
      if (this.clouds[i].x <= this.clouds[i].destX) {
        this.returnCloud(i);
        continue;
      }
    }

    if (this.cloudWaiter <= 0) {
      this.spawnCloud();
      this.cloudWaiter = Phaser.Math.Between(this.cloudWaitMin,this.cloudWaitMax) / 10;
    }
    else {
      this.cloudWaiter -= dt;
    }

    len = this.trees.length - 1;
    for (let i = len; i >= 0; i--) {
      this.trees[i].tick(dt);
      if (this.trees[i].x <= this.trees[i].destX) {
        this.returnTree(i);
        continue;
      }
    }

    if (this.treeWaiter <= 0) {
      this.spawnTree();
      this.treeWaiter = Phaser.Math.Between(this.treeWaitMin,this.treeWaitMax) / 10;
    }
    else {
      this.treeWaiter -= dt;
    }
  }
}